import { makeStyles } from '@material-ui/core';

import styled from 'utils/styled';

import backgroundSrc from 'assets/img/premis_house.png';

export const Container = styled('div')(() => ({
  position: 'relative',
  background: 'rgb(34, 64, 96)',
  '&::after': {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    minHeight: '100%',
    background:
      'transparent linear-gradient(180deg, #FFFFFF00 0%, #FFFFFF2E 100%) 0% 0% no-repeat',
    zIndex: 0,
  },
  '&::before': {
    position: 'fixed',
    content: "''",
    width: '100%',
    minHeight: '100%',
    backgroundImage: `url(${backgroundSrc})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '40%',
    backgroundPosition: 'bottom right',
    zIndex: 0,
  },
}));

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '100vh',
    padding: '2rem 1rem',
    zIndex: 5,
  },
  logo: {
    display: 'block',
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: 300,
    },
    [theme.breakpoints.down('sm')]: {
      width: 240,
    },
    [theme.breakpoints.down('xs')]: {
      width: 200,
    },
  },
  copy: {
    color: '#fff',
  },
}));
